// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CvssModifiedSubsequentImpactSchema = z.enum(['X','N','L','H','S'] as const);

export type CvssModifiedSubsequentImpactType = `${z.infer<typeof CvssModifiedSubsequentImpactSchema>}`

export default CvssModifiedSubsequentImpactSchema;
